<template>
    <div class="container d-flex justify-content-center align-items-center">
        <div v-if="loadingCheckout" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>


        <div v-if="loadingCheckout">
            <h1>Loading Checkout </h1>
        </div>
    </div>
</template>

<script>

import {
    createShopifyCheckout
} from '../services/shopify'

export default {
    data() {
        return {
            loadingCheckout: true,
        }
    },
    mounted() {
        const { query } = this.$route;

        const { variant_id, quantity } = query;

        const email = localStorage.getItem('mxdUserName')
        const userId = localStorage.getItem('userId')

        createShopifyCheckout({
            line_items: [
                {
                    variant_id,
                    quantity
                }
            ],
            email,
            user_id: userId
        })
            .then(r => {
                console.log(r.data);
                window.location.href = r.data.web_url;
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.loadingCheckout = false
            })



    }
}
</script>

<style lang="scss" scoped></style>